import React from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';

import './index.scss';

const DownloadAnswerSheetsButton = ({
  children,
  containerClassName,
  setModalOpen = () => {},
}) => (
  <div className={`DownloadASBtn ${containerClassName || ''}`}>
    <Button isSecondary onClick={() => setModalOpen(true)}>
      {children}
    </Button>
  </div>
);

export default DownloadAnswerSheetsButton;
